import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ActionSetFilterPayload {
    data: any;
}

type ActionSetFilter = PayloadAction<ActionSetFilterPayload>;

const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        stationFilter: {
            text: '',
            type: '',
        },
        cubeFilter: {
            text: '',
            type: '',
        },
    },
    reducers: {
        setStationFilter(state, { payload: { data: {text, type} } }: ActionSetFilter) {
            state.stationFilter = { text, type };
        },
        setCubeFilter(state, { payload: { data: {text, type} } }: ActionSetFilter) {
            state.cubeFilter = { text, type };
        }
    },
});

export const { setStationFilter, setCubeFilter } = filterSlice.actions;

export default filterSlice.reducer;
